import { Controller } from "stimulus"

export default class extends Controller {
  connect = () => {
    this.currentTime()
  }

  currentTime = () => {
    var date = new Date()
    var hour = date.getHours()
    var min = date.getMinutes()
    var sec = date.getSeconds()

    hour = this.updateTime(hour)
    min = this.updateTime(min)
    sec = this.updateTime(sec)

    this.element.innerText = hour + ":" + min + ":" + sec

    // TODO: Clear timeout on disconnect.
    setTimeout(() => {
      this.currentTime()
    }, 1000)
  }

  updateTime = (k) => {
    if (k < 10) {
      return "0" + k
    }
    else {
      return k
    }
  }
}
